angular.module('GlobalControllers')

  .service('pricing', ['$mdDialog', '$location', 'api', function($mdDialog, $location, api) {

    this.open = false;
    var self = this;
    self.prices = [];

    this.getPrices = function() {
      if(!self.prices.length) {
        api.getPrices().then(function (data) {
          var keys = Object.keys(data).sort(function(a, b) {
            return a - b;
          });
          var getPeriod = function(day) {
            var translater = {
              "15": "15 Jours",
              "31": "1 Mois",
              "92": "3 Mois",
              "365": "1 An",
            };
            return translater[day];
          };

          for (var i = 0; i < keys.length; i++) {
            self.prices.push({
              "value": keys[i],
              "price": data[keys[i]],
              "period": getPeriod(keys[i]),
              "pricePerDay": parseFloat(data[keys[i]] / keys[i]).toPrecision(2)
            });
          }
        });
      }

      return self.prices;
    };

    this.getPrices$ = function() {
        return api.getPrices().then(function (data) {
          var keys = Object.keys(data).sort(function(a, b) {
            return a - b;
          });
          var getPeriod = function(day) {
            var translater = {
              "15": "15 Jours",
              "31": "1 Mois",
              "92": "3 Mois",
              "365": "1 An",
            };
            return translater[day];
          };

          return keys.map(function(key) {
            return {
              "value": key,
              "price": data[key],
              "period": getPeriod(key),
              "pricePerDay": parseFloat(data[key] / key).toPrecision(2)
            }
          });
        });
    };

    this.showPrices = function(ev) {

      if (!self.open) {
        self.open = true;

        $mdDialog.show({
          templateUrl: '/ng1/www/modules/global/payment/html/dialog_pricing.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          // if an event is given, it's an user action
          clickOutsideToClose: (ev) ? true : false,
          preserveScope: true,
          controller: ["$scope", "$mdDialog", "EXAM", "exam", function DialogController($scope, $mdDialog, EXAM, exam) {
            $scope.examData = exam.examData;
            $scope.exam = EXAM;
            $scope.prices = self.getPrices();

            $scope.cancel = function() {
              $location.url('/');
              $mdDialog.cancel();
            };

            $scope.close = function() {
              $mdDialog.cancel();
            };

          }],
          onRemoving: function() {
            self.open = false;
          }
        });
      }


    };

  }
  ]);
